import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import { translate } from "@td/shared_utils";
import { Link } from "@td/ui";
import classNames from "classnames";

const EditButton = React.memo(({ className, ...props }) => (
  <div
    className={classNames(styles.editButtonContainer)}
  >
    <Link
      {...props}
      className={classNames(styles.editButton, className)}
    >
      {translate(null, "provider_panel.list_view", "edit_button")}
    </Link>
  </div>
));

EditButton.propTypes = {
  className: PropTypes.string,
};

EditButton.displayName = "EditButton";

export default EditButton;
